/* eslint-disable no-use-before-define,no-restricted-globals */
import React from 'react'
import { Loading, hideModal, getState, arrayFrom } from '../../twd'
// import useAlerts from './use-alerts'
import Grid from './grid'

export default () => {

    // let { status, count, holdingAlerts } = useAlerts()
    let Last = getState('header.alerts')
    let holdingAlerts = arrayFrom(Last.value.alerts)


    return <React.Fragment>
    <div
        data-name="alerts-modal"
        className="modal-dialog modal-lg">
    <div className="modal-content">
        <div className="modal-header">
            <button
                data-name="alerts-modal-close"
                className="close"
                aria-label="close"
                type="button"
                onClick={hideModal}>
            <i className="material-icons" aria-hidden="true">close</i>
            </button>

            <h2 className="modal-title text-center vertical-offset-sm">Bond Alerts</h2>

            <div className="container">
            <Loading status={status}>
                <div className="row">
                <div className="col-md-12 text-left" style={{
                    background: '#ffffff',
                    border: 'solid 1px #e4e4e4',
                    padding: '10px',
                    maxHeight: '300px',
                    overflowY: 'auto',

                }}>
                <Grid alerts={holdingAlerts} />
                </div>
                </div>
            </Loading>
            </div>
        </div>


        <div className="modal-footer">
        <div className="row">
        <div className='col-md-4'></div>
        <div className='col-md-4'>
            <button
                data-name="alerts-modal-close-button"
                className="btn btn-block btn-primary"
                type="button"
                onClick={hideModal}
            >Close</button>
        </div>
        <div className='col-md-4'></div>
        </div>
        </div>
    </div>
    </div>

    </React.Fragment>
}



